/** Shared by chat persistence and login. An ID is only a selector; the server authorizes it. */
export const CHAT_STORAGE_KEY = "okm-chat-state";
export const CHAT_STATE_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export function getSavedConversationId(): string | undefined {
  try {
    const state = JSON.parse(localStorage.getItem(CHAT_STORAGE_KEY) ?? "null");
    if (!state || Date.now() - state.savedAt > CHAT_STATE_MAX_AGE_MS) return undefined;
    return typeof state.conversationId === "string" ? state.conversationId : undefined;
  } catch {
    return undefined;
  }
}
